import React from 'react';
import { Target, CheckCircle } from 'lucide-react';
export function ForWhoSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-95">
      <div className="max-w-3xl mx-auto" data-id="element-96">
        <div className="text-center mb-10" data-id="element-97">
          <div className="flex justify-center mb-4" data-id="element-98">
            <Target className="w-16 h-16 text-red-500" data-id="element-99" />
          </div>
          <h2 className="text-4xl font-black text-gray-900 uppercase tracking-tight" data-id="element-100">
            PARA QUIÉN ES
          </h2>
        </div>

        <div className="bg-red-50 rounded-3xl p-8 md:p-12 border-2 border-red-100 shadow-xl" data-id="element-101">
          <p className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-102">
            Este kit es ideal para padres que:
          </p>

          <ul className="space-y-6" data-id="element-103">
            {['quieren ayudar a su hijo a aprender mejor', 'sienten que su hijo se distrae fácilmente', 'desean acompañar las tareas escolares', 'buscan herramientas claras y prácticas', 'quieren comprender cómo funciona el aprendizaje infantil'].map((item, index) => <li key={index} className="flex items-center bg-white p-4 rounded-xl shadow-sm" data-id="element-104">
                <CheckCircle className="h-8 w-8 text-red-500 mr-4 flex-shrink-0" data-id="element-105" />
                <span className="text-xl font-semibold text-gray-800" data-id="element-106">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}